export const ROUTES = {
  // Shared
  HOME: "/",
  REGISTER: "/register",
  LOGIN: "/login",
  LOGOUT: "/logout",
  ANONYMOUS_UPLOAD: "/anonymous-upload/:token",
  VERIFY_EMAIL: "/verify-email",
  VERIFY_EMAIL_TOKEN: "/verify-email/:token",
  RESET_PASSWORD_EMAIL: "/reset-password",
  RESET_PASSWORD_TOKEN: "/password-reset/:token",
  FAQ: "/faq",
  ABOUT_US: "/about-us",
  ABOUT_PRODUCT: "/about-product",
  CONTACT_US: "/contact-us",
  PRICING: "/pricing",
  TERMS_AND_CONDITIONS: "/vseobecne-obchodni-podminky",
  PRIVACY_POLICY: "/zasady-zpracovani-osobnich-udaju",

  // Client
  ONBOARDING_BUILDING: "/onboarding/building",
  ONBOARDING_COLLECTION_POINTS: "/onboarding/collection-points",
  DASHBOARD: "/client/dashboard",
  CLIENT_BUILDING_DETAILS: "/client/buildings/:buildingId",
  CLIENT_BUILDING_CARD: "/client/buildings/:buildingId/card",
  CLIENT_ADD_BUILDING: "/client/buildings/add",
  CLIENT_EDIT_BUILDING: "/client/buildings/:buildingId/edit",
  CLIENT_UPLOAD_INVOICE: "/client/invoices/upload",
  CLIENT_UPLOAD_INVOICE_COL_POINT: "/client/buildings/:buildingId/collection-points/:collectionPointId/invoices/upload",
  CLIENT_UPLOAD_CONSUMPTION: "/client/consumptions/upload",
  CLIENT_UPLOAD_CONSUMPTION_COL_POINT: "/client/buildings/:buildingId/collection-points/:collectionPointId/consumptions/upload",
  CLIENT_EDIT_INVOICE: "/client/invoices/:invoiceId/edit",
  CLIENT_EDIT_INVOICE_COL_POINT: "/client/buildings/:buildingId/collection-points/:collectionPointId/invoices/:invoiceId/edit",
  CLIENT_EDIT_CONSUMPTION: "/client/consumptions/:consumptionId/edit",
  CLIENT_EDIT_CONSUMPTION_COL_POINT: "/client/buildings/:buildingId/collection-points/:collectionPointId/consumptions/:consumptionId/edit",
  CLIENT_DATA_QUEUE: "/client/buildings/:buildingId/data-queue",
  UNDER_REVIEW: "/under-review",
  CLIENT_ADD_COLLECTION_POINT: "/client/buildings/:buildingId/collection-points/add",
  CLIENT_EDIT_COLLECTION_POINT: "/client/buildings/:buildingId/collection-points/:collectionPointId/edit",
  CLIENT_BUILDING_GROUPS: "/client/building-groups",
  CLIENT_SUBSCRIPTION: "/client/subscription",
  CLIENT_PRICELIST: "/client/pricelist",
  CLIENT_CHECKOUT_PAID: "/client/checkout/paid",
  CLIENT_CHECKOUT_CANCELLED: "/client/checkout/cancelled",
  CLIENT_SETTINGS: "/client/settings",

  // Admin
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_CLIENTS: "/admin/clients",
  ADMIN_CLIENT_DETAIL: "/admin/clients/:clientId",
  ADMIN_BUILDING_DETAIL: "/admin/clients/buildings/:buildingId",
  ADMIN_BUILDING_CARD: "/admin/clients/buildings/:buildingId/card",
  ADMIN_ADMINS: "/admin/admins",
  ADMIN_ADMIN_DETAIL: "/admin/admins/:adminId",
  ADMIN_FREQUENTLY_ASKED_QUESTIONS: "/admin/faq",
  ADMIN_FREQUENTLY_ASKED_QUESTIONS_DETAIL: "/admin/faq/:id?",
  ADMIN_FREQUENTLY_ASKED_QUESTIONS_FORM: "/admin/faq/:id?",
  ADMIN_DELETED_ITEMS: "/admin/deleted-items",
} as const;
